import React, { lazy, Suspense } from 'react';

const MediaPlayer = lazy(() => import('./index.lazy'));

const renderLoader = () => <p>Loading</p>;

const MediaPlayerSuspense = (props) => (
  <Suspense fallback={renderLoader()}>
    <MediaPlayer {...props} />
  </Suspense>
);

export default MediaPlayerSuspense;
